import layoutAdmin from "@/layouts/layoutAdmin.vue";
import dashboard from "@/views/module/dashboard/dashboard.vue";
import productSetup from "@/views/module/inventory/productManagement/productSetup.vue";
import productList from "@/views/module/inventory/productManagement/productList.vue";
import supplierSetup from "@/views/module/inventory/supplierManagement/supplierSetup.vue";
import invRequistion from "@/views/module/inventory/requistionManagement/invRequistion.vue";
import invRequistionRecord from "@/views/module/inventory/requistionManagement/invRequistionRecord.vue";
import viewRequisition from "@/views/module/inventory/requistionManagement/viewRequisition.vue";
import customerSetup from "@/views/module/inventory/customerManagement/customerSetup.vue";
import issueEntrySetup from "@/views/module/inventory/directIssueManagement/issueEntrySetup.vue";
import issueEntryRecord from "@/views/module/inventory/directIssueManagement/issueEntryRecord.vue";
import directReceive from "@/views/module/inventory/receiveManagement/directRecevie.vue";
import directRecevieRecord from "@/views/module/inventory/receiveManagement/directRecevieRecord.vue";
import viewDirectReceive from "@/views/module/inventory/receiveManagement/viewDirectReceive.vue";
import poReceive from "@/views/module/inventory/receiveManagement/poReceive.vue";
import poReceiveRecord from "@/views/module/inventory/receiveManagement/poReceiveRecord.vue";
import viewPoReceive from "@/views/module/inventory/receiveManagement/viewPoReceive.vue";
import lcReceive from "@/views/module/inventory/receiveManagement/lcReceive.vue";
import lcReceiveRecord from "@/views/module/inventory/receiveManagement/lcReceiveRecord.vue";
import addTransfer from "@/views/module/inventory/itemTransferManagement/addTransfer.vue";
import transferRecord from "@/views/module/inventory/itemTransferManagement/transferRecord.vue";
import inventoryRecords from "@/views/module/inventory/inventoryRecords.vue";
import inventoryDetails from "@/views/module/inventory/inventoryDetails.vue";
import requisitionDeliverySetup from "@/views/module/inventory/deliveryManagement/requisitionDeliverySetup.vue";
import requisitionDeliveryRecords from "@/views/module/inventory/deliveryManagement/requisitionDeliveryRecords.vue";
import salesInvoiceDeliverySetup from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliverySetup.vue";
import salesInvoiceDeliveryRecords from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryRecords.vue";
import gatePassSetup from "@/views/module/inventory/gatePassManagement/gatePassSetup.vue";
import gatePassRecords from "@/views/module/inventory/gatePassManagement/gatePassRecords.vue";
import gatePassInvoice from "@/views/module/inventory/gatePassManagement/gatePassInvoice.vue";
import requisitionDeliveryInvoice from "@/views/module/inventory/deliveryManagement/requisitionDeliveryInvoice.vue";
import salesInvoiceDeliveryInvoice from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryInvoice.vue";
import viewIssueEntryInvoice from "@/views/module/inventory/directIssueManagement/viewIssueEntryInvoice.vue";
// reports
import productMappingReport from "@/views/module/inventory/reports/productMappingReports.vue";
import supplierMappingReport from "@/views/module/inventory/reports/supplierMappingReports.vue";
import stockReport from "@/views/module/inventory/reports/stockReports.vue";
import transferrequestView from "@/views/module/inventory/itemTransferManagement/transferRecordView.vue";
import inventorySummaryReports from "@/views/module/inventory/reports/inventorySummaryReports.vue";
import inventoryStockAlertReport from "@/views/module/inventory/reports/inventoryStockAlertReport.vue";

//Return Management
import purchaseReturn from "@/views/module/inventory/returnManagement/purchaseReturn.vue";
import purchaseReturnRecord from "@/views/module/inventory/returnManagement/purchaseReturnRecord.vue";
import purchaseReturnDetails from "@/views/module/inventory/returnManagement/purchaseReturnDetails.vue";

import salesReturn from "@/views/module/inventory/returnManagement/salesReturn.vue";
import salesReturnRecord from "@/views/module/inventory/returnManagement/salesReturnRecord.vue";
import salesReturnDetails from "@/views/module/inventory/returnManagement/salesReturnDetails.vue";

import productionRequisitionDeliverySetup from "@/views/module/inventory/deliveryManagement/productionRequisitionDelivery.vue";
import productionRequisitionDeliveryRecords from "@/views/module/inventory/deliveryManagement/productionRequisitionDeliveryRecords.vue";


export default [
  {
    path: "/inventory",
    name: "inventory",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Inventory",
    },
    children: [
      {
        path: "dashboard",
        meta: {
          breadcrumb: ["Dashboard"],
        },
        component: dashboard,
      },
      

      {
        path: "add-supplier",
        name: "add-supplier",
        meta: {
          breadcrumb: ["Supplier", "Add Supplier"],
        },
        component: supplierSetup,
      },
      {
        path: "add-requistion",
        name: "add-requistion",
        meta: {
          breadcrumb: ["Requisition Management", "Add Requisition"],
        },
        component: invRequistion,
      },
      {
        path: "requistion-record",
        name: "requistion-record",
        meta: {
          breadcrumb: ["Requisition Management", "Requisition Record"],
        },
        component: invRequistionRecord,
      },
      {
        path: "view-requisition/:id",
        name: "view-requisition",
        meta: {
          breadcrumb: ["General Requisition", "View Requisition"],
        },
        component: viewRequisition,
      },
      {
        path: "add-customer",
        name: "add-customer",
        meta: {
          breadcrumb: ["Customer", "Add Customer"],
        },
        component: customerSetup,
      },
     
      
      {
        path: "issue-entry",
        name: "issue-entry",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Entry"],
        },
        component: issueEntrySetup,
      },
      {
        path: "issue-record",
        name: "issue-record",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Record"],
        },
        component: issueEntryRecord,
      },
      {
        path: "view-issue-invoice",
        name: "view-issue-invoice",
        meta: {
          breadcrumb: ["Direct Issue Management", "View Issue Invoice"],
        },
        component: viewIssueEntryInvoice,
      },
      {
        path: "direct-receive",
        name: "direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Receive"],
        },
        component: directReceive,
      },
      {
        path: "direct-receive-records",
        name: "direct-receive-records",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Record"],
        },
        component: directRecevieRecord,
      },
      {
        path: "view-direct-receive/:id",
        name: "view-direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "View Direct Receive"],
        },
        component: viewDirectReceive,
      },
      {
        path: "po-receive",
        name: "po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "PO Receive"],
        },
        component: poReceive,
      },
      {
        path: "po-receive-records",
        name: "po-receive-records",
        meta: {
          breadcrumb: ["PO Recieve Management", "PO Record"],
        },
        component: poReceiveRecord,
      },
      {
        path: "view-po-receive/:id",
        name: "view-po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "View PO Receive"],
        },
        component: viewPoReceive,
      },
      {
        path: "lc-receive",
        name: "lc-receive",
        meta: {
          breadcrumb: ["LC Receive Management", "LC Receive"],
        },
        component: lcReceive,
      },
      {
        path: "lc-receive-records",
        name: "lc-receive-records",
        meta: {
          breadcrumb: ["LC Recieve Management", "LC Record"],
        },
        component: lcReceiveRecord,
      },
      
      //Item Transfer
      {
        path: "add-transfer",
        name: "add-transfer",
        meta: {
          breadcrumb: ["Item Transfer", "Add Transfer"],
        },
        component: addTransfer,
      },
      {
        path: "transfer-record",
        name: "transfer-record",
        meta: {
          breadcrumb: ["Item Transfer", "Transfer Record"],
        },
        component: transferRecord,
      },

      // Inventory Records
      {
        path: "records",
        name: "inventory-records",
        meta: {
          breadcrumb: ["Inventory", "Inventory Records"],
        },
        component: inventoryRecords,
      },

      // Inventory Details (Transaction Log)
      {
        path: "details",
        name: "inventory-details",
        meta: {
          breadcrumb: ["Inventory", "Inventory Details"],
        },
        component: inventoryDetails,
      },
      
      //Delivery Management

      {
        path: "requisition-delivery",
        name: "requisition-delivery",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Setup"],
        },
        component: requisitionDeliverySetup,
      },
      {
        path: "requisition-delivery-records",
        name: "requisition-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Records"],
        },
        component: requisitionDeliveryRecords,
      },
      {
        path: "view-requisition-delivery-invoice",
        name: "view-requisition-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Invoice"],
        },
        component: requisitionDeliveryInvoice,
      },

      
      {
        path: "sale-delivery",
        name: "sale-delivery",
        meta: {
          breadcrumb: ["Inventory", "Sales Invoice Delivery Setup"],
        },
        component: salesInvoiceDeliverySetup,
      },
      {
        path: "sale-delivery",
        name: "sale-delivery",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Setup"],
        },
        component: salesInvoiceDeliverySetup,
      },
      {
        path: "sale-delivery-records",
        name: "sale-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Records"],
        },
        component: salesInvoiceDeliveryRecords,
      },
      {
        path: "view-sale-delivery-invoice",
        name: "view-sale-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Invoice"],
        },
        component: salesInvoiceDeliveryInvoice,
      },

      //Gate Pass management  

      {
        path: "add-gate-pass",
        name: "add-gate-pass",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Setup"],
        },
        component: gatePassSetup,
      },
      {
        path: "gate-pass-record",
        name: "gate-pass-record",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Records"],
        },
        component: gatePassRecords,
      },
      {
        path: "view-gate-pass-invoice",
        name: "view-gate-pass-invoice",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Invoice"],
        },
        component: gatePassInvoice,
      },
      {
        path: "product-mapping-report",
        name: "product-mapping-report",
        meta: { breadcrumb: ["Product Mapping Reports"] },
        component: productMappingReport,
      },
      {
        path: "supplier-mapping-report",
        name: "supplier-mapping-report",
        meta: { breadcrumb: ["Supplier Mapping Reports"] },
        component: supplierMappingReport,
      },
      {
        path: "stock-report",
        name: "stock-report",
        meta: { breadcrumb: ["Stock Reports"] },
        component: stockReport,
      },
      {
        path: "transfer-record-view",
        name: "transfer-record-view",
        meta: {
          breadcrumb: ["Inventory", "Transfer Record View"],
        },
        component: transferrequestView,
      },
      {
        path: "purchase-return",
        name: "purchase-return",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return"],
        },
        component: purchaseReturn,
      },
      {
        path: "purchase-return-record",
        name: "purchase-return-record",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return List"],
        },
        component: purchaseReturnRecord,
      },
      {
        path: "purchase-return-details/:id",
        name: "purchase-return-details",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return Details"],
        },
        component: purchaseReturnDetails,
      },

      {
        path: "sales-return",
        name: "sales-return",
        meta: {
          breadcrumb: ["Inventory", "Sales Return"],
        },
        component: salesReturn,
      },
      {
        path: "sales-return-record",
        name: "sales-return-record",
        meta: {
          breadcrumb: ["Inventory", "Sales Return List"],
        },
        component: salesReturnRecord,
      },
      {
        path: "sales-return-details/:id",
        name: "sales-return-details",
        meta: {
          breadcrumb: ["Inventory", "Sales Return Details"],
        },
        component: salesReturnDetails,
      },

      {
        path: "summary-report",
        name: "summary-report",
        meta: {
          breadcrumb: ["Inventory", "Summary Report"],
        },
        component: inventorySummaryReports,
      },
      {
        path: "stock-alert-report",
        name: "stock-alert-report",
        meta: {
          breadcrumb: ["Inventory", "Stock Alert Report"],
        },
        component: inventoryStockAlertReport,
      },
      {
        path: "production-requisition-delivery",
        name: "production-requisition-delivery",
        meta: {
          breadcrumb: ["Inventory", "Production Requisition Delivery"],
        },
        component: productionRequisitionDeliverySetup,
      },
      {
        path: "production-requisition-delivery-records",
        name: "production-requisition-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Production Requisition Delivery Records"],
        },
        component: productionRequisitionDeliveryRecords,
      },

    ],
  },
];
